import type React from "react";
import { useEffect } from "react";
import { ExperimentFlags } from "@shared/utils.experimentation";
import { useFeatureFlag } from "hooks";
import { trackExperimentViewed } from "tracking/hooks/useExperimentViewed";

export const USJourneyABTestTracking: React.FC = () => {
  const [usJourneyExperimentLoading, usJourneyExperimentValue] = useFeatureFlag(
    ExperimentFlags.PAGE_EXPERIMENT_US_JOURNEY,
    "2"
  );

  useEffect(() => {
    if (!usJourneyExperimentLoading && usJourneyExperimentValue !== "2") {
      trackExperimentViewed(
        ExperimentFlags.PAGE_EXPERIMENT_US_JOURNEY,
        +usJourneyExperimentValue
      );
    }
  }, [usJourneyExperimentLoading, usJourneyExperimentValue]);

  return null;
};
